import React, { useEffect, useCallback, useMemo } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import { boxsetsFetchData } from '../actions';
import { CardGridLoading } from '../v2/components/loading/CardGridLoading';
import translate from './TranslateHOC';
import CardGrid from './CardGrid';
import PageMeta from './PageMeta';
import { PAGE_TITLE_SEPARATOR } from '../constants';
import LoadingError from './alerts/LoadingError';
import PageTitle from './PageTitle';
import Tag from './Tag';

function BoxSets({
  strings,
  boxsets = {},
  boxsetsIsLoading,
  boxsetsHasErrored,
  fetchBoxsets,
  curLang,
  auth,
}) {
  const boxsetCards = useMemo(
    () => boxsets.cards && Object.keys(boxsets.cards),
    [boxsets.cards]
  );
  const memoizedFetchBoxSets = useCallback(() => {
    fetchBoxsets();
  }, [fetchBoxsets]);

  useEffect(() => {
    memoizedFetchBoxSets();
    window.scrollTo(0, 0);
  }, [curLang, memoizedFetchBoxSets]);

  if (boxsetsIsLoading) {
    return (
      <BoxSetsContainer auth={auth} className="main">
        <PageTitle title={boxsets.title} />
        <CardGridLoadingContainer auth={auth}>
          <CardGridLoading />
        </CardGridLoadingContainer>
      </BoxSetsContainer>
    );
  }

  if (boxsetsHasErrored) {
    return (
      <BoxSetsContainer auth={auth} className="main">
        <LoadingError errorMessage={strings.sorryLoading} />
      </BoxSetsContainer>
    );
  }

  return (
    <BoxSetsContainer auth={auth} className="main">
      <PageMeta
        title={`${strings.categories} ${PAGE_TITLE_SEPARATOR} ${boxsets.title}`}
        description={strings.metaDescriptionBoxsets}
      />
      <PageTitle title={boxsets?.title}>
        {boxsetCards && boxsetCards.length > 0 && (
          <Tag inlineMargin={true}>
            {boxsetCards.length}
            {boxsetCards.length > 1
              ? strings.programmesAvailable
              : strings.programmeAvailable}
          </Tag>
        )}
      </PageTitle>

      {boxsetCards && boxsetCards.length > 0 && (
        <CardGridContainer>
          <CardGrid
            items={boxsets.cards}
            gridType="centered"
            itemsIsLoading={boxsetsIsLoading}
            itemsHasErrored={boxsetsHasErrored}
            countBool={true}
          />
        </CardGridContainer>
      )}
    </BoxSetsContainer>
  );
}

const BoxSetsContainer = styled.div`
  margin-top: 24px;
  ${(props) => !props.auth && `padding-top: 0 !important;`}
  ${(props) => props.auth && `padding-top: 127px;`}
  @media screen and (min-width: 768px) {
    ${(props) => !props.auth && `padding-top: 127px !important;`}
    padding-top: 127px;
  }
`;

const CenteredContent = styled.div`
  margin: auto;
  max-width: 1595px;
`;

const CardGridContainer = styled(CenteredContent)``;

const CardGridLoadingContainer = styled(CenteredContent)`
  margin: auto;
  max-width: 1595px;
  ${(props) =>
    !props.auth &&
    `
    padding: 0 20px;
    @media screen and (min-width: 768px) {
      padding: 0;
    }
  `}
`;

const mapStateToProps = (state) => {
  return {
    auth: state.auth.authenticated,
    curLang: state.curLang,
    boxsets: state.boxsets.success,
    boxsetsIsLoading: state.boxsets.loading,
    boxsetsHasErrored: state.boxsets.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchBoxsets: () => dispatch(boxsetsFetchData()),
  };
};

export default translate(connect(mapStateToProps, mapDispatchToProps)(BoxSets));
